<template>
    <Create
        :list-uuid="selectedListUuid"
        :lists="pickerLists"
        @update:list-uuid="selectedListUuid = $event"
        @hide-dialog="hideDialog()"
        @confirm-custom="confirmCustom"
        v-if="showCreate"
    />
    <ConfirmCustom
        :custom="custom"
        :list-type="listType"
        :list-uuid="selectedListUuid"
        @hide-dialog="hideDialog()"
        v-else-if="showConfirmCustom"
    />
</template>
<script setup>
import { computed, reactive, ref } from "vue";
import { usePage } from "@inertiajs/vue3";
import Create from "./Create.vue";
import ConfirmCustom from "./ConfirmCustom.vue";
import { useModalogStore } from "@/stores/modalog.js";

const modalogStore = useModalogStore();

modalogStore.$subscribe(
    (mutation, state) => {
        console.log("modalogStore.$subscribe callback");
        console.log(mutation, state);
        console.log(state.hasModalog);

        // if (mutation.type === 'hasModalog' && mutation.payload === false) {
        if (!!state.hasModalog) {
            step.value = 1;
        }
    },
    { detached: true },
);

const props = defineProps(["listType", "listUuid"]);

// When the trigger doesn't specify a destination list (e.g. the dashboard
// "Add Gift" button), offer a picker of the user's wish lists and thread the
// selection through both the URL and custom flows.
const userLists = computed(
    () => usePage().props.auth?.user?.data?.wishlists ?? [],
);
const pickerLists = computed(() => (props.listUuid ? [] : userLists.value));
const selectedListUuid = ref(props.listUuid ?? null);

//--- State
const custom = reactive({});
const step = ref(1);
const type = ref("url");

//--- Computed
const showCreate = computed(() => {
    return step.value === 1 && modalogStore.hasModalog;
});

const showConfirmCustom = computed(() => {
    return (
        step.value === 2 && type.value === "custom" && modalogStore.hasModalog
    );
});

const confirmCustom = (data) => {
    console.log(data);
    custom.value = data;
    step.value = 2;
    type.value = "custom";
};

//--- Methods
function hideDialog() {
    modalogStore.closeModalog();
    // this.$emit('hide-add-item-dialog')
    // this.$store.commit('hideModal')
}

// export default {
//     created () {
//         this.$store.subscribe((mutation, state) => {
//             if (mutation.type === 'hasModalog' && mutation.payload === false) {
//                 this.step = 1
//             }
//         })
//     },
// }
</script>
